import {
  buildUrlWithAuth,
  RIDER_ENDPOINTS,
  getRiderId,
} from '../config/apiConfig'
import parseExternalDelivery from '../scripts/parseExternalDelivery'

export default {
  // URL de l'endpoint Multi Request de l'API d'agrégation
  url() {
    return 'https://api.monrapidoo.com/rapidoo-aggregation/multi-request?group=ultraxeno'
  },

  method: 'POST',

  format() {
    const riderId = getRiderId() || 'MISSING'

    // Requête 1: Commandes
    const ordersUrl = buildUrlWithAuth(RIDER_ENDPOINTS.ORDER_LIST, {
      riderId,
      status: 'confirmed,accepted,preparing,picked_up,ready_for_pickup,arrived',
    })

    // Requête 2: Colis
    const packagesUrl = buildUrlWithAuth(RIDER_ENDPOINTS.PACKAGE_LIST, {
      riderId,
      status: 'confirmed,accepted,picked_up,ready_for_pickup,arrived,assigned',
    })

    return {
      requests: [
        {
          method: 'GET',
          url: ordersUrl,
        },
        {
          method: 'GET',
          url: packagesUrl,
        },
      ],
    }
  },

  parse(raw = {}) {
    if (!Array.isArray(raw?.data)) {
      return {
        statusCode: 500,
        message: 'Erreur du serveur',
        data: { hasActiveDelivery: false, delivery: null },
      }
    }

    const [ordersRes, packagesRes] = raw.data

    const extractDeliveries = multiRequestResult => {
      if (!multiRequestResult || !multiRequestResult.success) return []
      const { data: res } = multiRequestResult
      const data = res.data?.data || res.data?.items || res.data
      return Array.isArray(data) ? data : []
    }

    const orders = extractDeliveries(ordersRes)
    const packages = extractDeliveries(packagesRes)

    const filterActive = item =>
      item && !['delivered', 'completed', 'cancelled'].includes(item.status)

    const activeOrder = orders.find(filterActive)
    const activePackage = packages.find(filterActive)

    if (activeOrder) {
      return {
        statusCode: 200,
        message: 'Ok',
        data: {
          hasActiveDelivery: true,
          delivery: parseExternalDelivery({
            ...activeOrder,
            deliveryType: 'order',
          }),
        },
      }
    }

    if (activePackage) {
      return {
        statusCode: 200,
        message: 'Ok',
        data: {
          hasActiveDelivery: true,
          delivery: parseExternalDelivery({
            ...activePackage,
            deliveryType: 'package',
          }),
        },
      }
    }

    return {
      statusCode: 200,
      message: 'Aucune livraison active',
      data: { hasActiveDelivery: false, delivery: null },
    }
  },
}
